module.exports = __webpack_public_path__ + "static/media/RRD3-BG3.a75fe4b8.jpg";